import io, { serverAlias } from '@/module/io'
import MC from '@/module/MC'
import axios from 'axios'
/**
 * Go login
 */
export const signIn = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_login`, payload, res => {
      res.data.msg = res.msg
      resolve(res.data)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}
/**
 *
 * 单点登录 【登录商户平台成功后调用后台接口登录帆软】
 */
export const loginFanruan = payload => {
  const host = process.env.NODE_ENV === 'production' ? '' : '/otherApi'
  return new Promise((resolve, reject) => {
    axios.post(`${host}/webroot/decision/hdLogin`, payload, res => {
      resolve(res)
    }, err => {
      reject(err)
    })
  })
}

/**
 *
 * 退出登录
 */
export const LoginOut = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_logout`, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}
/**
 * Get business info
 */
export const getBusinessInfo = payload => {
  return new Promise((resolve, reject) => {
    const { system } = MC.config
    io.get(`${serverAlias.merchant}/1.0/acc`, { sys: payload || system }, res => {
      // 临时针对resList 数据做处理
      _.map(res.data.resList, v => {
        if (v.reModule === '商品中心') {
          v.reEngSystem = 'commodity'
          if (v.children) {
            _.map(v.children, v1 => {
              if (v1.reMenu === '组合商品') {
                v1.appCode = 'commodity'
              }
              v1.reEngSystem = 'commodity'
              if (v1.children) {
                _.map(v1.children, v2 => {
                  v2.reEngSystem = 'commodity'
                })
              }
            })
          }
        }
      })

      // 临时针对resList 营销菜单数据处理
      _.map(res.data.resList, v => {
        if (v.reModule === '营销中心') {
          // v.appCode = 'marketing'
          v.children.unshift({
            'id': '7ed673beb2504794886c380d3619c640',
            'reParent': 'eca33301da3a4da089e52be2e1f6ab63',
            'reSystem': '海典健康微商城',
            'reEngSystem': 'medical',
            'appCode': 'marketing',
            'reModule': '营销中心',
            'reMenu': '场景营销',
            'reButton': '',
            'reMethod': '',
            'reType': '1',
            'rePath': 'marketing-manager',
            'reUrl': '/scenes/home',
            'reIcon': null,
            'isvalid': 1,
            'createName': 'System',
            'createTime': '2019-11-25 12:30:14',
            'modifyName': null,
            'modifyTime': '2021-05-08 10:47:12',
            'startTime': '2020-04-09 10:04:08',
            'endTime': '2120-03-16 10:04:08'
          }, {
            'id': '7ed673beb2504794886c380d3619c640',
            'reParent': 'eca33301da3a4da089e52be2e1f6ab63',
            'reSystem': '海典健康微商城',
            'reEngSystem': 'medical',
            'appCode': 'marketing',
            'reModule': '营销中心',
            'reMenu': '策划营销',
            'reButton': '',
            'reMethod': '',
            'reType': '1',
            'rePath': 'marketing-manager',
            'reUrl': '/plan/home',
            'reIcon': null,
            'isvalid': 1,
            'createName': 'System',
            'createTime': '2019-11-25 12:30:14',
            'modifyName': null,
            'modifyTime': '2021-05-08 10:47:12',
            'startTime': '2020-04-09 10:04:08',
            'endTime': '2120-03-16 10:04:08'
          })
        }
      })

      MC.setConfig({
        userInfo: res.data,
        merCode: res.data.merCode
      })
      // BaiduTj
      // _hmt.push(['_trackEvent', 'app', '登录商户号', res.data.merCode]) // eslint-disable-line

      resolve(res.data)
    }, e => {
      reject(e)
    })
  })
}

/**
 * Get business list
 */
export const getBusinessData = () => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/mer/_queryMerchantByMobile`, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

/**
 * Toggle business
 */
export const switchBusiness = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_changeMerchant/${payload.merCode}`, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    })
  })
}

/**
 * Get user info
 */
export const getUser = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_queryUserInfo`, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    })
  })
}

/**
 * Edit user info
 */
export const editUser = payload => {
  return new Promise((resolve, reject) => {
    io.put(`${serverAlias.merchant}/1.0/acc`, payload, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

/**
 * Edit password
 */

export const editUserPwd = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_chgPwd`, payload, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

/**
 * 校验当前登录手机号是否激活过
 */
export const checkSignPhone = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_queryAccountStatus/${payload}`, res => {
      resolve(res)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

/**
 * Check the graphic verification code
 */
export const sendMsgCode = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/verification/_sendCode`, payload, res => {
      resolve(res)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

/**
 * Check SMS check code
 */
export const checkMsgCode = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/verification/_checkVerificationCode`, payload, res => {
      resolve(res)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

/**
 * Setting password and activate
 */
export const setPassword = payload => {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.merchant}/1.0/acc/_activateAccount`, payload, res => {
      resolve(res)
    }, e => {
      reject(e)
    }, { emulateJSON: false })
  })
}

export const queryCenterStore = payload => {
  return new Promise((resolve, reject) => {
        io.get(`${serverAlias.merManager}/1.0/store/queryCenterStore/${merCode}`, { merCode }, res => { // eslint-disable-line
      resolve(res)
    }, e => {
      reject(e)
    })
  })
}

/**
 *
 * 存健康 授权登录商户平台
 */
export function healthyLogin (payload) {
  return new Promise((resolve, reject) => {
    io.get(`${serverAlias.merchant}/1.0/cjksso/_login`, { token: payload }, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    })
  })
}

/**
 *
 * 企业微信后台登录商户平台
 */
export function loginMerchant (auth_code) {
  return new Promise((resolve, reject) => {
    io.get(`hydee-ewx-honey/1.0/login/fromAdmin/${auth_code}`, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    })
  })
}

/**
 * erp数据同步监控
 */
export function getSyncErpData (merCode) {
  return new Promise((resolve, reject) => {
    io.post(`${serverAlias.syncerp}/1.0/monitor/unified/interface?merCode=${merCode}`, res => {
      resolve(res.data)
    }, e => {
      reject(e)
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/module/apis/user.js